module.exports = __webpack_public_path__ + "static/media/running.7abee0be.svg";